import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import Grid from "../../../components/Grid";
import { ShowBtn } from "@/components/Show";
import { CreateLoaderInput } from "../../../components/Loaders";
import { DeleteBtn } from "@/components/Delete";
import { TableDataProps } from "@/pages/Roles";
import { getShowRole, deleteRoleData } from "@/Api/roles";
import { SetStateAction } from "react";
import { Dispatch } from "react";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";

export const TableData = ({
  dataApi,
  updateFront,
}: {
  dataApi: TableDataProps[];
  updateFront: Dispatch<SetStateAction<TableDataProps[]>>;
}) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  return (
    <>
      <Table className="bg-zinc-50 rounded dark:bg-[#2c2c2c]">
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead className="text-center">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dataApi?.map((item) => {
            return (
              <TableRow key={item?.id}>
                <TableCell>{item?.name}</TableCell>
                <TableCell className="flex justify-center">
                  <div className="flex gap-3 w-full justify-center">
                    <If condition={hasPermission("edit-position")}>
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => navigate(`/cargos/editar/${item?.uuid}`)}
                        className="size-7 p-0 text-slate-900 hover:bg-stone-950/10 dark:text-[#F4F4F5]"
                      >
                        <Pencil className="size-5" />
                      </Button>
                    </If>

                    <If condition={hasPermission("delete-position")}>
                      <DeleteBtn
                        params={{
                          func: deleteRoleData,
                          funcParams: item?.uuid,
                        }}
                        updateFront={() =>
                          updateFront((prev) => {
                            const newData = [
                              ...prev.filter(
                                (data) => data?.uuid !== item?.uuid
                              ),
                            ];
                            return newData;
                          })
                        }
                        referenceLabel={item?.name}
                      />
                    </If>
                    <If condition={hasPermission("show-position-details")}>
                      <ShowBtn
                        labels={{ title: "Visualizar Cargo" }}
                        params={{
                          func: getShowRole,
                          funcParams: item?.uuid,
                        }}
                        render={(responseApi: TableDataProps) => (
                          <div className="w-full h-auto">
                            <div className="flex flex-col gap-3">
                              <Grid.Item name="Nome" flex={0}>
                                {responseApi?.name}
                              </Grid.Item>
                            </div>
                          </div>
                        )}
                        loader={<CreateLoaderInput lines={4} />}
                      />
                    </If>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};
